import { FormGroup as MuiFormGroup, styled } from '@mui/material'

export const FormGroup = styled(MuiFormGroup, { name: 'FormGroup' })(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  width: '100%',
  padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  borderTop: `1px solid ${theme.palette.divider}`,
}))
